const PATIENT_CONTACT_ROUTES = {
	PATIENT_CONTACTS: '/patient-contacts',
	PATIENT_CONTACT: '/patient-contacts/:contactId',
}

const DICTATION_ROUTES = {
	DICTATIONS: '/dictations',
	DICTATION: '/dictations/:dictationId',
}

const AUTH_ROUTES = {
	LOGIN: '/login',
	REGISTER: '/register',
	FORGOT_PASSWORD: '/forgot-password',
	VERIFY_EMAIL: '/verify-email',
	RESET_PASSWORD: '/reset-password',
	SET_PASSWORD: '/set-password',
	VERIFY_MFA: '/verify-mfa',
	AUTHENTICATION_REDIRECT: '/authentication-redirect',
	LOGIN_SUCCESS: '/login-success',
}

const SETTINGS_ROUTES = {
	SETTINGS: '/settings',
	SETTINGS_TAB: '/settings/:tab',
}

const MAINTENANCE_ROUTES = {
	NOT_FOUND: '/404',
	INSIGHTS: '/insights',
	INSIGHTS_TAB: '/insights/:tab',
	PAID_FEATURE: '/paid-feature',
}

const PUBLIC_ROUTES = {
	EXTERNAL_FEEDBACK: '/external-feedback',
}

const ROUTES = {
	...PATIENT_CONTACT_ROUTES,
	...AUTH_ROUTES,
	...SETTINGS_ROUTES,
	...DICTATION_ROUTES,
	...MAINTENANCE_ROUTES,
	...PUBLIC_ROUTES,
}

export default ROUTES
